import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import YahenLogoMark from './YahenLogoMark';

const TAGLINE = 'Управление турами от ЯШЕН';

export default function LogoMain({ showTagline = false }) {
  return (
    <Stack direction="row" spacing={1.25} alignItems="center">
      <YahenLogoMark size={28} />
      <Stack spacing={0.25} sx={{ minWidth: 0 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            lineHeight: 1.1,
            letterSpacing: '0.02em',
            color: 'text.primary'
          }}
        >
          ЯШЕН
        </Typography>
        {showTagline && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ lineHeight: 1.2, whiteSpace: 'normal' }}
          >
            {TAGLINE}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

LogoMain.propTypes = {
  showTagline: PropTypes.bool
};
